import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Alert as MuiAlert, Divider as MuiDivider } from '@mui/material'
import { colors } from '@global/constants/colors'

export const Container = styled.div`
  display: flex;
  padding-top: 12px;
`

export const TargetName = styled.div`
  flex-shrink: 1;
  justify-content: flex-start;
`

export const MultiTarget = styled.div`
  flex: 1;
`

export const LastChecked = styled.div`
  flex-shrink: 1;
  justify-content: flex-end;
`

export const icon = css`
  margin-right: 4px;
  cursor: pointer;
`

const AlertTitle = css`
  font-weight: 500;
  font-size: 14px;
`

export const SuccessAlertTitle = styled('div')`
  ${AlertTitle};
  color: ${colors.green.darkText};
`

export const ErrorAlertTitle = styled('div')`
  ${AlertTitle};
  color: ${colors.red.darker};
`

export const Alert = styled(MuiAlert)`
  &.-status-complete,
  &.-status-success {
    background-color: #edf7ed;
    color: #222;
  }

  &.-status-pending {
    background-color: #e9f4fe;
    color: #222;
  }

  &.-status-error {
    background-color: #feeceb;
    color: #222;
  }

  border-radius: 8px;
`

export const Divider = styled(MuiDivider)`
  margin-top: 5px;
  margin-bottom: 5px;
`

export const Content = styled.div`
  .-status-complete &,
  .-status-success & {
    color: ${colors.green.darkText};
  }

  .-status-pending & {
    color: #222;
  }

  .-status-error & {
    color: ${colors.red.darker};
  }
`
